const points = [
  "Cover starts on delivery or Plan activation, whichever is later",
  "12 or 24 months of cover, as selected at purchase",
  "Repair, replacement or Store Credit — no cash settlement",
  "For luggage, laptop backpacks, messenger bags, handbags and travel accessories",
];

export default function ValueSection() {
  return (
    <section className="tw-bg-white">
      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2">
        {/* Image */}
        <div className="tw-relative tw-h-96 md:tw-h-[640px]">
          <img
            src="/eume/eume-ad-split.png"
            alt="Travellers with EUME luggage and bags"
            className="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover"
          />
        </div>

        {/* Copy */}
        <div className="tw-flex tw-flex-col tw-justify-center tw-gap-[22px] tw-px-6 tw-py-16 md:tw-pl-20 md:tw-pr-10 lg:tw-pr-[120px] md:tw-py-20">
          <h2 className="tw-text-3xl md:tw-text-[38px] tw-leading-[46px] tw-font-semibold tw-tracking-[-0.01em] tw-text-[#111]">
            What your plan covers
          </h2>

          <p className="tw-text-base md:tw-text-[17px] tw-leading-7 tw-text-[#4B5563]">
            The EUME Accidental Care Plan works alongside EUME’s Manufacturing
            Warranty: defects stay with the warranty, while this plan protects
            against sudden accidental physical damage.
          </p>

          <ul className="tw-flex tw-flex-col tw-gap-3 tw-pt-1.5">
            {points.map((point) => (
              <li key={point} className="tw-flex tw-items-start tw-gap-3">
                <span className="tw-shrink-0 tw-rounded-full tw-bg-[#E7F6EE] tw-px-1.5 tw-py-0.5 tw-text-[13px] tw-font-bold tw-text-[#12A150]">
                  ✓
                </span>
                <span className="tw-text-base tw-leading-6 tw-text-[#111]">
                  {point}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
